import React from 'react';

import { SearchType } from '@/context/LockerManagementFileUploadContext';
import { BuildPath } from  '@/helpers/Paths';
import { Groups, Users } from  '@/interfaces/LockerManagement';
import { Truncate } from  '@/helpers/Text';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { BasicCheckbox, IconLibrary, ThriveIcon } from 'thrive-components';

interface TableRowProps {
    data: Users | Groups,
    isSelected?: boolean,
    type: SearchType
    isChecked: boolean
    addToSelected: (type: SearchType, data: any) => void
    removeFromSelected: (type: SearchType, data: any) => void
}

const SearchUsersOrGroupsTableRow = ({data, isSelected=false, type, isChecked, addToSelected, removeFromSelected }: TableRowProps): JSX.Element => {

    function addRemoveItem(isChecked, data, type) {
        isChecked ? removeFromSelected(type, data) : addToSelected(type,data)
    }

    function getName() {
        return type === 'user' ? (data as Users).name : (data as Groups).groupName
    }

    function subTitleBuilder(){

        if (type !== 'user') {
            return `${(data as Groups).totalUsersInGroup} Users`
        }

        let subTitle = ""

        // Display name 
        if ((data as Users).displayName && (data as Users).displayName !== (data as Users).name){
            subTitle = (data as Users).displayName.toString();
        }

        // Department 
        if ((data as Users).department){

            if (subTitle) subTitle += " / "

            subTitle += (data as Users).department.toString();
        }

        // Job title
        if ((data as Users).jobTitle){
            
            if (subTitle) subTitle += " / "

            subTitle += (data as Users).jobTitle.toString();
        }

        return subTitle;
    }
    
    return (
        <li className='search-result'>
            <div className='search-result-details'>
                {type === 'user' && (
                    <img 
                        className='search-result-profile-pic'
                        src={(data as Users).profilePicUrl
                            ? (data as Users).profilePicUrl
                            : `${BuildPath()}/images/locker/icons/default-profile.png`
                        }
                        alt=""
                        onError={(e) => (e.target as HTMLImageElement).src=`${BuildPath()}/images/locker/icons/default-profile.png`}
                    />
                )}
                <div className='search-results-text'>
                    {getName().length >= 50 &&
                        <ReactTooltip id={`tooltip-name-${getName()}`} place="top" className='thrive-tooltip no-width'  aria-hidden="true">
                            <span>{getName()}</span>
                        </ReactTooltip> 
                    }
                    <span data-tooltip-id={`tooltip-name-${getName()}`} className={`name ${isSelected ? 'selected' : ''}`}>{Truncate(getName(), 50)}</span>
                    <span className={`title ${isSelected ? 'selected' : ''}`}>
                        {Truncate(subTitleBuilder(), 75)}
                    </span>
                </div>
            </div>

            {!isSelected
                ?   <BasicCheckbox
                        ariaLabel={getName()}
                        id={getName().split(' ').join('')}
                        isChecked={isChecked} 
                        onChange={()=> addRemoveItem(isChecked, data, type)} 
                        label={getName()} 
                    />
                :   <button
                        className="file-upload-delete-btn delete-user"
                        onClick={() => removeFromSelected(type, data)}
                        aria-label={`remove ${getName()}`}
                    > 
                        <ThriveIcon 
                            iconName={IconLibrary.BIN} 
                            sizeInPx='12'
                            color='var(--thriveRed)'
                        />
                    </button>
                }
        </li>
)}

export default SearchUsersOrGroupsTableRow;